import React, { Component } from 'react';
import FormItem from '../../../components/FormItem/index';
import userStorage from '../../../utils/storage';
import { Form, Input, Button, message } from 'antd';
import services from '../../../services/api';
class UserAdd extends Component {
  constructor() {
    super();
    this.state = {
      treeData: [],
      detail: {}
    };
  }

  componentDidMount() {
    if (this.props.actionType) {
      this.actionType = this.props.actionType;
      if (this.actionType === 'update') {
        this.username = this.props.record.username;
        this.getDetail();
      }
    }
  }
  /**获取详情 */
  getDetail = () => {
    services.usersConfig.queryOne({ username: this.username }).then(data => {
      if (data.code === 0) {
        this.setState({
          detail: data.data
        });
        this.props.form.setFieldsValue({
          username: data.data.username,
          des: data.data.des,
          right_level: data.data.right_level
        });
      } else {
        message.error(data.msg);
      }
    });
  };
  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('输入的两次密码不一致');
    } else {
      callback();
    }
  };
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = {
          username: values.username,
          password: values.password,
          des: values.des,
          right_level: values.right_level
        };

        if (this.props.actionType === 'update') {
          params.oldPassword = values.oldPassword;
        }
        services.usersConfig[this.props.actionType](params).then(data => {
          if (data.code === 0) {
            message.success(data.msg);
            this.props.closeModal({});
          } else {
            message.error(data.msg);
          }
        });
      }
    });
  };

  render() {
    const { username, res, right_level } = this.props.record || {};
    const passwordFormItems =
      this.props.actionType === 'update'
        ? [
            {
              label: {
                label: '原密码',
                className: 'tantuer-form-item'
              },
              name: 'oldPassword',
              options: {
                initialValue: '',
                rules: [{ required: true, message: '请输入原密码' }]
              },
              component: (
                <Input
                  placeholder="原密码"
                  type="password"
                  className="default"
                />
              )
            },
            {
              label: {
                label: '新密码',
                className: 'tantuer-form-item'
              },
              name: 'password',
              options: {
                initialValue: '',
                rules: [{ required: true, message: '请输入新密码' }]
              },
              component: (
                <Input
                  placeholder="新密码"
                  type="password"
                  className="default"
                />
              )
            },
            {
              label: {
                label: '重复新密码',
                className: 'tantuer-form-item'
              },
              name: 'confirmPassword',
              options: {
                initialValue: '',
                rules: [
                  { required: true, message: '请重复输入新密码' },
                  {
                    validator: this.compareToFirstPassword
                  }
                ]
              },
              component: (
                <Input
                  placeholder="重复新密码"
                  type="password"
                  className="default"
                  onBlur={this.handleConfirmBlur}
                />
              )
            }
          ]
        : [
            {
              label: {
                label: '密码',
                className: 'tantuer-form-item'
              },
              name: 'password',
              options: {
                initialValue: '',
                rules: [{ required: true, message: '请输入密码' }]
              },
              component: (
                <Input placeholder="密码" type="password" className="default" />
              )
            },
            {
              label: {
                label: '重复密码',
                className: 'tantuer-form-item'
              },
              name: 'confirmPassword',
              options: {
                initialValue: '',
                rules: [
                  { required: true, message: '请重复输入密码' },
                  {
                    validator: this.compareToFirstPassword
                  }
                ]
              },
              component: (
                <Input
                  placeholder="重复密码"
                  type="password"
                  className="default"
                  onBlur={this.handleConfirmBlur}
                />
              )
            }
          ];
    const formItems = [
      {
        label: {
          label: '用户名',
          className: 'tantuer-form-item'
        },
        name: 'username',
        options: {
          initialValue: username,
          rules: [{ required: true, message: '请输入用户名' }]
        },
        component: (
          <Input
            placeholder="用户名"
            className="large"
            disabled={this.props.actionType === 'update'}
          />
        )
      },
      ...passwordFormItems,
      {
        label: {
          label: '权限',
          className: 'tantuer-form-item'
        },
        name: 'right_level',
        options: {
          initialValue: right_level
        },
        component: (
          <Input
            placeholder="权限"
            className="default"
            disabled={
              userStorage.userInfo.right_level === 0 ||
              userStorage.userInfo.username === this.state.detail.username
            }
          />
        )
      },
      {
        label: {
          label: '备注',
          className: 'tantuer-form-item'
        },
        name: 'res',
        options: {
          initialValue: res
        },
        component: <Input placeholder="备注" className="default" />
      }
    ];

    return (
      <div>
        <Form onSubmit={this.handleSubmit} className="login-form">
          <div className="tantuer-field-area">
            {formItems.map((item, key) => {
              return <FormItem key={key} form={this.props.form} item={item} />;
            })}
          </div>

          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            提交
          </Button>
        </Form>
      </div>
    );
  }
}

export default Form.create()(UserAdd);
